import React, { useEffect, useState } from "react";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import { Button, ConfigProvider, Layout, Menu, Modal, Select } from "antd";
import Typography from "../../components/Typography";
import { COLORS } from "../../constants/Colors";
import { ASSET_BASE_PATH } from "../../constants/Config";
import { DownOutlined, MenuOutlined } from "@ant-design/icons";
import PrivacyPolicyModal from "../../containers/PrivacyPolicyModal";
import CookiePolicyModal from "../../containers/CookiePolicyModal";
import CookieSettingsModal from "../../containers/CookieSettingsModal";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { FormattedMessage, useIntl } from "react-intl";
import { Option } from "antd/es/mentions";
import loginService from "../../utils/services/LoginService";
import { langActionn } from "../../utils/redux/actions/langAction";
import { useDispatch } from "react-redux";
import _ from "lodash";

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const PolicyModal = (props) => {
  const {
    isOpen,
    onCancel,
    onOpenPrivacyPolicy,
    onOpenCookiePolicy,
    Lang,
    setIsChangeLang,
  } = props;
  // const [selectedMenuKey, setSelectedMenuKey] = useState('1.1');

  const items = [
    getItem(
      Lang === "EN" ? (
        <>
          <Typography
            size="16px"
            isBold
            color={COLORS.Primary}
            className="pb-1 pl-3 "
          >
            EN -{" "}
            <FormattedMessage id="englishLanguage" defaultMessage="English" />
          </Typography>
        </>
      ) : (
        <>
          <Typography
            size="16px"
            isBold
            color={Lang === "TH" ? COLORS.Primary : null}
            className="pb-1 pl-2"
          >
            TH - <FormattedMessage id="thaiLanguage" defaultMessage="Thai" />
          </Typography>
        </>
      ),
      "1",
      null,
      [
        getItem(
          <Typography
            size="16px"
            isBold
            className="pb-1 pt-2"
            color={Lang !== "EN" ? "#909AAF" : null}
            style={{ paddingLeft: "0px" }}
          >
            EN -{" "}
            <FormattedMessage id="englishLanguage" defaultMessage="English" />
          </Typography>,

          "1.1"
        ),
        getItem(
          <Typography
            size="16px"
            isBold
            className="pb-2 pt-3"
            color={Lang !== "TH" ? "#909AAF" : null}
          >
            TH - <FormattedMessage id="thaiLanguage" defaultMessage="Thai" />
          </Typography>,

          "1.2"
        ),
      ],
      "group"
    ),
    // getItem(
    //   <Typography size='16px' isBold className='pb-1 pt-2' color={Lang !== 'EN' ? '#909AAF' : null} style={{ paddingLeft: '0px' }}>
    //     EN - <FormattedMessage id='englishLanguage' defaultMessage='English' />
    //   </Typography>,

    //   '1.1'
    // ),
    // getItem(
    //   <Typography size='16px' isBold className='pb-2 pt-3' color={Lang !== 'TH' ? '#909AAF' : null}>
    //     TH - <FormattedMessage id='thaiLanguage' defaultMessage='Thai' />
    //   </Typography>,

    //   '1.2'
    // ),
  ];

  const handleChangeMenu = (newKey) => {
    // const newSelectedKey = [newKey];
    // setSelectedMenuKey(newSelectedKey);
    if (_.get(newKey, "key") === "1.1") {
      setIsChangeLang(true);
      localStorage.setItem("lang", "EN");
    }
    if (_.get(newKey, "key") === "1.2") {
      setIsChangeLang(true);
      localStorage.setItem("lang", "TH");
    }
    //console.log('newKey', _.get(newKey, 'key'));
  };

  return (
    <Modal open={isOpen} onCancel={onCancel} footer={[]}>
      <div className="d-flex flex-column align-items-center">
        <div onClick={onOpenPrivacyPolicy}>
          <Typography
            size="16px"
            isBold
            color={COLORS.Primary}
            className="pt-5"
          >
            <FormattedMessage
              id="labelPrivacyPolicy"
              defaultMessage="Privacy Policy"
            />
          </Typography>
        </div>
        <div onClick={onOpenCookiePolicy}>
          <Typography
            size="16px"
            isBold
            color={COLORS.Primary}
            className="pt-5"
          >
            <FormattedMessage
              id="labelCookiePolicy"
              defaultMessage="Cookie Policy"
            />
          </Typography>
        </div>
        <div className="pt-5">
          <div>
            <Menu
              theme="light"
              // selectedKeys={selectedMenuKey}
              mode="inline"
              className="signup"
              items={items}
              style={{
                justifyContent: "start",
                // alignItems: 'baseline',
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "Bold",
                border: "none",
                paddingLeft: "0px",
              }}
              inlineIndent={0}
              onClick={handleChangeMenu}
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["1"]}
            />
          </div>
          {/* <Select
            bordered={false}
            value={Lang || 'EN'}
            onSelect={(e) => {
              setIsChangeLang(true);
              localStorage.setItem('lang', e);
            }}
            style={{ border: '0px' }}
          >
            <Option value={'EN'}>
              <Typography size='16px' isBold color={Lang === 'EN' ? COLORS.Primary : null} className='pt-2' style={{ cursor: 'pointer' }}>
                EN - <FormattedMessage id='englishLanguage' defaultMessage='English' />
              </Typography>
            </Option>
            <Option value={'TH'} className='pt-3 pb-1'>
              <Typography size='16px' isBold color={Lang === 'TH' ? COLORS.Primary : null} className='pt-2' style={{ cursor: 'pointer' }}>
                TH - <FormattedMessage id='thaiLanguage' defaultMessage='Thai' />
              </Typography>
            </Option>
          </Select> */}
        </div>
      </div>
    </Modal>
  );
};

const HomeLayout = (props) => {
  const { children } = props;
  const isDesktop = useIsDesktop();
  const [isOpenPrivacyPolicy, setIsOpenPrivacyPolicy] = useState(false);
  const [isOpenCookiePolicy, setIsOpenCookiePolicy] = useState(false);
  const [isOpenCookieSettings, setIsOpenCookieSettings] = useState(false);
  const [isShowCookieBar, setIsShowCookieBar] = useState(true);
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [isOpenPolicyMenu, setIsOpenPolicyMenu] = useState(false);
  const [selectLang, setSelectLang] = useState(localStorage.getItem("lang"));
  const [isChangeLang, setIsChangeLang] = useState(false);
  const intl = useIntl();
  const dispatch = useDispatch();
  const Lang = localStorage.getItem("lang");

  useEffect(() => {
    const hasCookie = checkCookie("acceptCookiesloopMerchant"); // Replace with your cookie name
    if (hasCookie) {
      setIsShowCookieBar(false);
    } else {
      setIsShowCookieBar(true);
    }
  }, []);

  useEffect(() => {
    getLang();
    // //console.log('Lang: ', selectLang);
  }, [isChangeLang]);

  function checkCookie(cookieName) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === cookieName) {
        return true;
      }
    }
    return false;
  }

  const getLang = async (lang) => {
    const _loginService = new loginService();

    const bodyLang = {
      companyId: process.env.REACT_APP_COMPANY_ID,
      lang: Lang || "EN",
      pageCode: "frontloopmerchant.lng.v1",
    };

    await _loginService
      .changeLangauge(bodyLang, selectLang)
      .then((response) => {
        //console.log('TestRE', response);
        if (_.get(response, "status") === 200) {
          dispatch(langActionn(_.get(response, "data[0]")));
          localStorage.setItem(
            "alllang",
            JSON.stringify(_.get(response, "data[0]"))
          );
          if (isChangeLang === true) {
            setTimeout(() => {
              window.location.reload();

              setIsChangeLang(false);
            }, 500);
          }
        }
      })
      .catch((err) => {
        //console.log('getCustomerProfile err:', err);
      });
  };

  const handleClickAcceptPolicy = () => {
    setAcceptPolicy(!acceptPolicy);
    //console.log('acceptPolicy: ', acceptPolicy);
  };

  const handleAcceptCookies = (name) => {
    //console.log('getCookieConsentValue: ', getCookieConsentValue(name));
  };

  const onOpenCookiePolicy = () => {
    handleOpenCookiePolicy();
    setIsOpenPolicyMenu(false);
  };

  const onOpenPrivacyPolicy = () => {
    handleOpenPrivacyPolicy();
    setIsOpenPolicyMenu(false);
  };

  const handleOpenCookiePolicy = () => {
    //console.log('open Modal');
    setIsOpenCookiePolicy(true);
  };

  const handleOpenPrivacyPolicy = () => {
    setIsOpenPrivacyPolicy(true);
  };

  const labelRenderSelect = (prop) => {
    console.log("labelV", prop);
    const { label, value } = prop;
    return (
      <span style={{ color: COLORS.White }}>
        {value === "EN"
          ? "EN - " +
            intl.formatMessage({
              id: "englishLanguage",
              defaultMessage: "English",
            })
          : "TH - " +
            intl.formatMessage({
              id: "thaiLanguage",
              defaultMessage: "Thai",
            })}
      </span>
    );
  };

  return (
    <>
      <Layout className="site-layout">
        <Header
          className="px-4"
          style={{
            background: COLORS.White,
            zIndex: 10,
            height: 64,
            maxHeight: 64,
          }}
        >
          <div className="d-flex flex-row justify-content-between align-items-center h-100">
            <img
              height="44px"
              src={`${ASSET_BASE_PATH}/assets/Logo_TC.png`}
              alt="logo"
            />
            {isDesktop ? (
              <div className="d-flex flex-row align-items-center">
                <div onClick={onOpenPrivacyPolicy}>
                  <Typography
                    size="14px"
                    isBold
                    color={COLORS.Primary}
                    style={{ cursor: "pointer" }}
                  >
                    <FormattedMessage
                      id="labelPrivacyPolicy"
                      defaultMessage="Privacy Policy"
                    />
                  </Typography>
                </div>
                <div onClick={onOpenCookiePolicy}>
                  <Typography
                    size="14px"
                    isBold
                    color={COLORS.Primary}
                    className="pl-4"
                    style={{ cursor: "pointer" }}
                  >
                    <FormattedMessage
                      id="labelCookiePolicy"
                      defaultMessage="Cookie Policy"
                    />
                  </Typography>
                </div>
                <Button
                  style={{ backgroundColor: "white", paddingTop: "0px" }}
                  type="primary"
                >
                  <div
                    style={{ backgroundColor: "#4DAD5B", borderRadius: "8px" }}
                  >
                    {/* <ConfigProvider
                      theme={{
                        components: {
                          Select: {
                            optionSelectedBg: COLORS.BgSelect,
                            optionSelectedColor: COLORS.Primary,
                            optionActiveBg: '#1677ff',
                          },
                        },
                      }}
                    > */}
                      <Select
                        bordered={false}
                        value={Lang || "EN"}
                        onSelect={(e) => {
                          setIsChangeLang(true);
                          localStorage.setItem("lang", e);
                          setSelectLang(e);
                        }}
                        style={{
                          border: "0px",
                          minWidth: "115px",
                        }}
                        suffixIcon={<DownOutlined style={{color: COLORS.White}} />}
                        labelRender={labelRenderSelect}
                      >
                        <Option value={"EN"}>
                          <Typography
                            size="14px"
                            isBold
                            style={{
                              cursor: "pointer",
                              color:
                                Lang === "EN" ? COLORS.Primary : COLORS.Dark,
                            }}
                          >
                            EN -{" "}
                            <FormattedMessage
                              id="englishLanguage"
                              defaultMessage="English"
                            />
                          </Typography>
                        </Option>
                        <Option value={"TH"}>
                          <Typography
                            size="14px"
                            isBold
                            style={{
                              cursor: "pointer",
                              color:
                                Lang === "TH" ? COLORS.Primary : COLORS.Dark,
                            }}
                          >
                            TH -{" "}
                            <FormattedMessage
                              id="thaiLanguage"
                              defaultMessage="Thai"
                            />
                          </Typography>
                        </Option>
                      </Select>
                    {/* </ConfigProvider> */}
                  </div>
                </Button>
              </div>
            ) : (
              <MenuOutlined
                style={{ color: COLORS.Primary, fontSize: "20px" }}
                onClick={() => setIsOpenPolicyMenu(true)}
              />
            )}
          </div>
        </Header>
        <Content
          style={{
            height: isDesktop ? "calc(102vh - 115px)" : "calc(105vh - 65px)",
            maxHeight: isDesktop ? "calc(100vh - 112px)" : "calc(100vh - 63px)",
            background: `url(${ASSET_BASE_PATH}/assets/Bg_Login.png)`,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            overflow: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
      {isDesktop ? (
        <Footer
          className={`d-flex align-items-center ${
            isDesktop ? "justify-content-start" : "justify-content-center"
          } px-4`}
          style={{
            height: 46,
            backgroundColor: COLORS.Primary,
          }}
        >
          <Typography size="12.5px" color={COLORS.White}>
            Powered by © RAPIDTECH Co., Ltd. (V 1.0)
          </Typography>
        </Footer>
      ) : null}

      {isShowCookieBar &&
        (isDesktop ? (
          <CookieConsent
            location="bottom"
            buttonText={intl.formatMessage({
              id: "btnAcceptAll",
              defaultMessage: "Accept All Cookies",
            })}
            cookieName="acceptCookiesloopMerchant"
            style={{ background: COLORS.White, textAlign: "left" }}
            buttonStyle={{
              background: COLORS.Primary,
              color: COLORS.White,
              fontSize: "14px",
              borderRadius: "5px",
              fontWeight: "bolder",
            }}
            expires={150}
            onAccept={() => {
              handleAcceptCookies("acceptAllCookies");
            }}
          >
            <div className="row">
              <div className="col-8">
                <h6 style={{ color: COLORS.Dark }}>
                  <FormattedMessage
                    id="cookieWebText1"
                    defaultMessage="This website uses cookies."
                  />
                </h6>
                <span style={{ color: COLORS.Dark }}>
                  <FormattedMessage
                    id="cookieWebText2"
                    defaultMessage='
                  We use cookies to optimize better performance and experience
                  on our website. You can set your consent of cookies by
                  clicking "Cookie Settings".'
                  />
                </span>
                <span
                  style={{ color: COLORS.Primary, cursor: "pointer" }}
                  onClick={handleOpenCookiePolicy}
                >
                  {" "}
                  <FormattedMessage
                    id="labelCookiePolicy"
                    defaultMessage="Cookies Policy"
                  />
                </span>
              </div>
              <div className="col-4">
                <button
                  style={{
                    float: "right",
                    background: COLORS.White,
                    border: "0",
                    fontWeight: "bolder",
                    borderRadius: "0px",
                    boxShadow: "none",
                    color: COLORS.Primary,
                    padding: "0px 0px",
                    outline: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setIsShowCookieBar(true);
                    setIsOpenCookieSettings(true);
                  }}
                >
                  <FormattedMessage
                    id="btnCookieSettings"
                    defaultMessage="Cookie Settings"
                  />
                </button>
              </div>
            </div>
          </CookieConsent>
        ) : (
          <div className="row">
            <CookieConsent
              location="bottom"
              buttonText=""
              buttonStyle={{
                backgroundColor: "white",
              }}
              style={{
                background: COLORS.White,
                display: "block",
                width: "100%",
              }}
              expires={150}
            >
              <h4 style={{ color: COLORS.Dark, marginBottom: "6%" }}>
                <FormattedMessage
                  id="cookieWebText1"
                  defaultMessage="This website uses cookies."
                />
              </h4>
              <span style={{ color: COLORS.Dark, fontSize: "14px" }}>
                <FormattedMessage
                  id="cookieWebText2"
                  defaultMessage='
                  We use cookies to optimize better performance and experience
                  on our website. You can set your consent of cookies by
                  clicking "Cookie Settings".'
                />
              </span>
              <span
                style={{
                  color: COLORS.Primary,
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                onClick={handleOpenCookiePolicy}
              >
                {" "}
                <FormattedMessage
                  id="labelCookiePolicy"
                  defaultMessage="Cookies Policy"
                />
              </span>

              <div style={{ height: "50px" }}>
                <button
                  style={{
                    float: "center",
                    color: COLORS.White,
                    border: "0",
                    fontWeight: "bolder",
                    boxShadow: "none",
                    background: COLORS.Primary,
                    outline: "none",
                    cursor: "pointer",
                    borderRadius: "5px",
                    fontWeight: "bolder",
                    marginTop: "15%",
                    width: "95%",
                    height: "100%",
                  }}
                  onClick={() => {
                    // Set the "acceptCookiesloopMerchant" cookie to true
                    document.cookie =
                      "acceptCookiesloopMerchant=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
                    // Perform any other necessary actions
                    handleAcceptCookies("acceptAllCookies");
                    setIsShowCookieBar(false);
                  }}
                >
                  <FormattedMessage
                    id="btnAcceptAll"
                    defaultMessage="Accept All Cookies"
                  />
                </button>
              </div>
              <div>
                <button
                  style={{
                    float: "center",
                    background: COLORS.White,
                    border: "0",
                    fontWeight: "bolder",
                    borderRadius: "0px",
                    boxShadow: "none",
                    color: COLORS.Primary,
                    padding: "0px 0px",
                    outline: "none",
                    cursor: "pointer",
                    marginTop: "24%",
                  }}
                  onClick={() => {
                    setIsShowCookieBar(true);
                    setIsOpenCookieSettings(true);
                  }}
                >
                  <FormattedMessage
                    id="btnCookieSettings"
                    defaultMessage="Cookie Settings"
                  />
                </button>
              </div>
            </CookieConsent>
          </div>
        ))}

      {!isDesktop && (
        <PolicyModal
          isOpen={isOpenPolicyMenu}
          onCancel={() => setIsOpenPolicyMenu(false)}
          onOpenPrivacyPolicy={() => {
            onOpenPrivacyPolicy();
            setIsOpenPolicyMenu(false);
          }}
          onOpenCookiePolicy={() => {
            onOpenCookiePolicy();
            setIsOpenPolicyMenu(false);
          }}
          onAcceptPolicy={handleClickAcceptPolicy}
          Lang={Lang}
          setIsChangeLang={setIsChangeLang}
        />
      )}

      <PrivacyPolicyModal
        isOpen={isOpenPrivacyPolicy}
        onCancle={() => {
          setIsOpenPrivacyPolicy(false);
        }}
        onAcceptPolicy={handleClickAcceptPolicy}
      />

      <CookiePolicyModal
        isOpen={isOpenCookiePolicy}
        onCancle={() => {
          setIsOpenCookiePolicy(false);
        }}
      />

      <CookieSettingsModal
        isOpen={isOpenCookieSettings}
        onCancle={() => {
          setIsOpenCookieSettings(false);
        }}
        setIsShowCookieBar={setIsShowCookieBar}
      />
    </>
  );
};

export default HomeLayout;
